import _ from 'lodash';
import { eventBus } from '_/helpers/eventBus';
import { api } from '_/services/api';

export default {
    props: {
        defaultValue: { type: [Boolean, String] },
        disabled: { type: Boolean },
        id: { required: true, type: [Number, String] },
        name: { required: true, type: String },
        refreshFields: { type: Number },
        value: { default: '', type: [String, Number] },
        focus: { default: false, type: Boolean },
    },

    data() {
        return {
            query: '',
            results: [],
            loading: false,
        };
    },

    methods: {
        createEventPayload(event) {
            return {
                event,
                id: event.target.id,
                name: event.target.name,
                value: event.target.value,
            };
        },

        emitValue(value) {
            const payload = {
                event: null,
                id: this.id,
                name: this.name,
                value,
            };
            this.$emit('change', payload);
            eventBus.$emit('fieldTypeChange', payload);
        },

        onIdInput(event) {
            this.$emit('change', this.createEventPayload(event));
            eventBus.$emit('fieldTypeChange', this.createEventPayload(event));
        },

        onBlur(event) {
            eventBus.$emit('fieldTypeBlur', this.createEventPayload(event));
        },

        onQueryInput: _.debounce(function () {
            this.search();
        }, 300),

        async search() {
            const q = (this.query || '').trim();
            if (q.length < 2) {
                this.results = [];
                return;
            }
            this.loading = true;
            try {
                const res = await api.get(`sports/matches/search?q=${encodeURIComponent(q)}&limit=20`);
                this.results = (res && res.body && res.body.data) || [];
            } catch (e) {
                this.results = [];
            } finally {
                this.loading = false;
            }
        },

        pick(match) {
            this.emitValue(match.sportradar_id);
            this.results = [];
            this.query = '';
        },

        teamLabel(match) {
            const home = match.home_team && match.home_team.name;
            const away = match.away_team && match.away_team.name;
            if (home && away) return `${home} vs ${away}`;
            return match.sportradar_id;
        },

        kickoffLabel(match) {
            if (!match.kickoff_at) return 'TBD';
            try {
                return new Date(match.kickoff_at).toISOString().slice(0, 10);
            } catch (e) {
                return match.kickoff_at;
            }
        },
    },

    mounted() {
        if (this.focus) {
            this.$nextTick(() => {
                const el = this.$el.querySelector('.match-picker-field__id');
                if (el) el.focus();
            });
        }
    },
};
